import { SingleDatePicker } from '@driftt/react-dates'
import { Button, Div, H2, H4, Label, Modal } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import moment from 'moment'
import { equals } from 'ramda'
import React, { useState } from 'react'

import { MOST_POPULATED_TIMEZONES } from 'constants/timezones'

import { HOUR_OPTIONS } from './constants'

import './styles.css'

const PlaybookSchedulerModal = ({ onSubmit, scheduledTask, onClose }) => {
  const [focusedInput, setFocusedInput] = useState(false)
  const [selectedDate, setSelectedDate] = useState(() => {
    if (scheduledTask) {
      return moment(scheduledTask.scheduledTime)
    } else {
      return moment()
    }
  })
  const [selectedTime, setSelectedTime] = useState(() => {
    if (scheduledTask) {
      return HOUR_OPTIONS.find((o) => {
        return equals(
          o.label,
          moment(scheduledTask.scheduledTime).format('h:mma')
        )
      })
    } else {
      return {
        label: '9:00am',
        value: moment('09:00:00', 'H:mm'),
      }
    }
  })
  const [selectedTimezone, setSelectedTimezone] = useState(() => {
    if (scheduledTask) {
      return MOST_POPULATED_TIMEZONES.find(
        (tz) => tz.value === scheduledTask.timeZone
      )
    } else {
      return {
        label: 'America/New_York (EST) -04:00',
        value: 'America/New_York',
      }
    }
  })

  const dateSelected = (date) => {
    return date && setSelectedDate(date)
  }

  const isValid = () => {
    if (scheduledTask) {
      return (
        !selectedDate.isSame(moment(scheduledTask.scheduledTime), 'day') ||
        !equals(
          selectedTime.label,
          moment(scheduledTask.scheduledTime).format('h:mma')
        ) ||
        !equals(selectedTimezone.value, scheduledTask.timeZone)
      )
    } else {
      return true
    }
  }

  return (
    <Modal
      open
      size="medium"
      className="playbook-scheduler-modal"
      onClose={onClose}
    >
      <H2>Schedule end date</H2>
      <H4>When would you like to disable this playbook?</H4>
      <Select
        options={MOST_POPULATED_TIMEZONES}
        label="Timezone"
        onChange={(option) => setSelectedTimezone(option)}
        value={selectedTimezone}
        className="playbook-scheduler-modal--timezone-select"
      />
      <Label>Date</Label>
      <div className="playbook-scheduler-modal--calendar">
        <SingleDatePicker
          date={selectedDate}
          onDateChange={dateSelected}
          focused={focusedInput}
          small
          onFocusChange={(payload) => setFocusedInput(payload.focused)}
          numberOfMonths={1}
          initialVisibleMonth={() => moment()}
          id="date_selection"
          hideKeyboardShortcutsPanel
        />
      </div>
      <Select
        label="Time"
        options={HOUR_OPTIONS}
        onChange={(option) => setSelectedTime(option)}
        value={selectedTime}
      />
      <Div className="playbook-scheduler-modal--buttons">
        <Button
          type="primary"
          disabled={!isValid()}
          onClick={() => {
            onSubmit({
              timeZone: selectedTimezone.value,
              action: 'DISABLE',
              scheduledTime: selectedDate
                .hour(selectedTime.value.hour())
                .minute(selectedTime.value.minute())
                .format('YYYY-MM-DDTHH:mm:ss'),
            })
            onClose()
          }}
        >
          Save
        </Button>
        <Button type="Secondary" onClick={onClose}>
          Cancel
        </Button>
      </Div>
    </Modal>
  )
}

export default PlaybookSchedulerModal
